import React, { CSSProperties } from 'react';
import { useAtom } from 'jotai';
import { approvalState } from '@/recoil/atom';
import { getApprovalCreateUrl } from '@/utils/urls';
import toAppWebviewUrl from '@/utils/approval/toAppWebviewUrl';
import {
  getApprovalAppTabName,
  isNativeApprovalType,
} from '@/utils/approval/approvalAppTab';

type P = {
  name: string;
  type: number;
  buttonStyle?: CSSProperties;
  onClose: () => void;
  onOpenWorkingHoursChange?: () => void;
  onOpenOvertimeRequest?: () => void;
  onOpenOvertimeAdjust?: () => void;
  onOpenAnnualLeave?: () => void;
};

const CreateApproval = ({
  name,
  type,
  buttonStyle,
  onClose,
  onOpenWorkingHoursChange,
  onOpenOvertimeRequest,
  onOpenOvertimeAdjust,
  onOpenAnnualLeave,
}: P) => {
  // NATIVE_APPROVAL_TYPES 밖의 양식은 자동으로 레거시행.
  const url = isNativeApprovalType(type)
    ? getApprovalCreateUrl(type)
    : `${process.env.NEXT_PUBLIC_IFRAME_URL}/intranet/approval/create?apv_type=${type}`;

  const [selectedState, setSelectedState] = useAtom(approvalState);

  const sendPostMessage = () => {
    const sendData = JSON.stringify({
      actionType: 'MOVE_TAB',
      tabName: getApprovalAppTabName(url),
      url: toAppWebviewUrl(url),
    });
    window?.ReactNativeWebView?.postMessage(sendData);
  };

  const handleClose = () => {
    onClose();
    setSelectedState({ ...selectedState, headerKey: 1 });
  };

  const handleOpen = () => {
    // 근태 양식: iframe 이동 대신 데스크탑과 동일한 Portal 모달을 연다.
    // 법인 제한/드로어 닫힘은 상위(ApprovalWirte)의 핸들러가 처리한다.
    if (type === 222) return onOpenWorkingHoursChange?.();
    if (type === 223) return onOpenOvertimeRequest?.();
    if (type === 224) return onOpenOvertimeAdjust?.();
    if (type === 231) return onOpenAnnualLeave?.();

    // 그 외 일반 품의
    if (window?.isRNWebview) {
      sendPostMessage();
    } else {
      window.open(url, '_blank');
    }
    handleClose();
  };

  return (
    <>
      <button
        key={`${name}`}
        style={{
          padding: '12px 0',
          textAlign: 'left',
          fontSize: '14px',
          ...buttonStyle,
        }}
        onClick={handleOpen}
      >
        {name}
      </button>
    </>
  );
};

export default CreateApproval;
